import type { FCWithChildren } from "~/types/react"

export * from "./TitledSection"

export type FormalLayoutProps = {
  sectionTitles: { title?: string; id?: string }[]
  title: string
}

export const FormalLayout: FCWithChildren<FormalLayoutProps> = ({
  title,
  sectionTitles,
  children,
}) => {
  return (
    <div className="my-8 grid gap-x-4 md:my-12 md:grid-cols-4">
      <div className="prose mb-8 dark:prose-dark md:col-span-3 md:col-start-2 md:mb-12 lg:prose-lg">
        <h1>{title}</h1>
      </div>
      <ul className="prose-sm mb-8 dark:prose-dark sm:prose">
        {sectionTitles.map(({ title: sectionTitle, id }) => {
          if (!id) return null

          return (
            <li key={id}>
              <a
                href={`#${id}`}
                className="font-display !text-primary-500 !no-underline theme-peach:!text-primary-800 dark:!text-secondary-500"
              >
                {sectionTitle}
              </a>
            </li>
          )
        })}
      </ul>
      <div className="prose dark:prose-dark md:col-span-3 lg:prose-lg">
        {children}
      </div>
    </div>
  )
}
